import React from "react";
import { ResponsiveCheckbox } from "./";
export const Concert = ({
  id,
  date,
  venue,
  value,
  setValue
}) => {
  const {
    name,
    city,
    state,
    country
  } = venue;
  const isSelected = value.find(checkedId => checkedId === id);

  const handleChange = () => {
    isSelected ? setValue(value.filter(checkedId => checkedId !== id)) : setValue(value.concat([id]));
  }; // Dates are coming in the format 2021-08-12T20:00:00.000Z


  const arr = date.replace('T', ' ').replace('Z', '').split(/[- :]/);
  const displayDate = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4]);
  const displayDateOptions = {
    month: "short",
    day: "numeric",
    year: "numeric"
  };
  return /*#__PURE__*/React.createElement(ResponsiveCheckbox, {
    checked: isSelected,
    onChange: handleChange,
    title: name,
    "data-javelin-name": isSelected ? "remove-concert" : "add-concert",
    "data-javelin-meta": id
  }, displayDate.toLocaleDateString("en-us", displayDateOptions), " \u2022 ", city, ",", " ", state, ", ", country);
};